import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Tooltip } from 'antd';

// Import components
import { Button } from 'components/elements';

// Import icons
import { ReactComponent as SearchIcon } from 'assets/icons/ic_nav_search.svg';

// Import variables
import { SECTIONS_ID } from 'helpers/variables';

const { SEARCH } = SECTIONS_ID;

const SearchButton = ({ toggle }) => {
	const { t } = useTranslation();

	const navItemTitle = t('common_header_nav_search');

	return (
		<Tooltip placement="bottom" title={navItemTitle}>
			<Button
				modifiers={['navIcon']}
				onClick={toggle}
				spaceRight="1rem"
				id={SEARCH}
				title={navItemTitle}
			>
				<SearchIcon aria-hidden="true" title={navItemTitle} />
			</Button>
		</Tooltip>
	);
};

SearchButton.propTypes = {
	toggle: PropTypes.func.isRequired
};

export default SearchButton;
